module.exports = __webpack_public_path__ + "static/media/Rest Api.582fec8f.png";